import React from 'react';

import { SiteStructure } from '@eventbrite/site-structure';

import { Layout } from '@eventbrite/eds-layout';

export const PageLayout = ({
    children,
    env,
    footerLinks,
    request,
    user,
    featureFlags,
}) => (
    <SiteStructure
        env={env}
        footerLinks={footerLinks}
        fullScreenMain={true}
        isEmbeddedView={false}
        request={request}
        user={user}
        featureFlags={featureFlags}
    >
        <Layout maxWidth="large" hasHorizontalGutters={true}>
            {children}
        </Layout>
    </SiteStructure>
);
